import React, { useState, useContext, useEffect } from "react";
import logo from "../../assets/images/logo.png";
import arrow from "../../assets/images/arrow.png";
import { VersionContext } from "../../context";
import { useNavigate } from "react-router-dom";
import { getPlatform } from "../../utils";
import "./index.css";

const Transfer = () => {
  const { appVersionData } = useContext(VersionContext);
  const navigate = useNavigate();
  let platform = getPlatform().toLocaleLowerCase();

  let environment = "chrome";

  if (platform === "ios") {
    navigate("/");
    return null;
  }
  const u = window.navigator.userAgent.toLowerCase();
  if (u.indexOf("micromessenger") !== -1) {
    environment = "Wechat";
  } else if (u.indexOf("alipay") !== -1) {
    environment = "Alipay";
  } else if (u.indexOf("dingtalk") !== -1) {
    environment = "Dingtalk";
  }

  if (environment && environment !== "Dingtalk") {
    navigate("/Android");
  }

  const appVersionNo = appVersionData[`${platform}VersionInfo`]?.appVersionNo;

  if (platform === 'android') {
    platform = 'Android'
  }

  return (
    <div className="transfer">
      <div className="homePgaeTop">
        <p>点击右上角按钮，然后在弹出的菜单中,</p>
        <p>点击浏览器中打开，即可安装</p>
        <img className="arrow" src={arrow}></img>
      </div>
      <div className="homePgaeContainer">
        <img className="logo" src={logo}></img>
        <p className="homePgaeContainer-title">{`喜茶门店通${platform}客户端`}</p>
        <p className="homePgaeContainer-p">立即下载，享受高效愉悦的办公工具</p>
        {appVersionNo && (
          <p className="homePgaeContainer-p">版本号：V{appVersionNo}</p>
        )}
        <p className="homePgaeContainer-p bottom">开发者：深圳灵感之茶科技有限公司</p>
      </div>
    </div>
  );
};

export default Transfer;
